/* template */
<template><page><base-container><div><cube-textarea :value="(textareaValue)" :placeholder="(placeholder)" :maxlength="(maxlength)" :disabled="(disabled)" :auto-focus="(autoFocus)" :focus="(focus)" :width="(width)" :indicator="(indicator)" @focus='(e)=>__invoke(e, [["handleFocus"]])' @blur='(e)=>__invoke(e, [["handleBlur"]])' @linechange='(e)=>__invoke(e, [["handleLineChange"]])' @input='(e)=>__invoke(e, [["handleInput"]])' @confirm='(e)=>__invoke(e, [["handleConfirm"]])' @keyboardheightchange='(e)=>__invoke(e, [["handleKeyboardHeightChange"]])'/><div :class='["textarea-options"]'><div :class='["title"]'>Options</div><div :class='["option-list"]'><div :class='["group"]'><div :class='["group-item"]'><div :class='["item"]'>disabled</div><mpx-switch :color="(switchColor)" :checked="(disabled)" @change='(e)=>__invoke(e, [["updateDisabled"]])'/></div><div :class='["group-item"]'><div :class='["item","sub"]'>maxlength</div><mpx-input type="number" :value="(_maxlength)" @input='(e)=>__invoke(e, [["updateMaxLength"]])' :class='["input-maxlength"]'/></div><div :class='["group-item","last"]'><div :class='["item","sub"]'>width</div><mpx-input :value="(_width)" @input='(e)=>__invoke(e, [["updateWidth"]])' :class='["input-width"]'/></div></div><div :class='["group"]'><div :class='["group-item"]'><div :class='["item"]'>indicator</div><mpx-switch :color="(switchColor)" :checked="(showIndicator)" @change='(e)=>__invoke(e, [["updateIndicator"]])'/></div><div :class='["group-item"]' v-if="(showIndicator)"><div :class='["item"]'>negative</div><mpx-switch :color="(switchColor)" :checked="(indicatorNegative)" @change='(e)=>__invoke(e, [["updateNegative"]])'/></div><div :class='["group-item","last"]' v-if="(showIndicator)"><div :class='["item"]'>remain</div><mpx-switch :color="(switchColor)" :checked="(indicatorRemain)" @change='(e)=>__invoke(e, [["updateRemain"]])'/></div></div></div></div></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_65805140"}'>
  .title
    padding: 15px
    margin-bottom: 15px
    font-size: 16px
    font-weight: 500
    color: #333
    border-bottom: 1px solid rgba(0, 0, 0, .1)

  .options
    margin-bottom: 15px
  .option-list
    .group
      margin-bottom: 15px
      border: 1px solid rgba(0, 0, 0, .1)
      border-radius: 5px
      .group-item
        display: flex
        align-items: center
        justify-content: space-between
        padding-right: 10px
        border-bottom: 1px solid rgba(0, 0, 0, .1)
        .item
          padding-left: 15px
          line-height: 52px
          height: 52px
          width: 120px
          text-align: left
        .sub
          font-size: 14px
          background-color: rgba(0, 0, 0, .04)
        .input-maxlength
        .input-width
          flex: 1
          margin-left: 15px
      .last
        border-bottom: none
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_65805140"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_65805140"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_65805140"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-textarea':getComponent(require("../../../packages/mpx-cube-ui/src/components/textarea/index.mpx?isComponent&outputPath=components%2Findex3de76d81%2Findex")),'mpx-switch':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-switch?isComponent"), {__mpxBuiltIn: true}),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>